import React from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import { FaTimes } from "react-icons/fa";

export default function WarningModal({
  hide,
  btnType = "error",
  btnBg = "bg-lightRed",
  errors = { error: [], menu: "" },
  ...props
}) {
  const Footer = () => {
    return (
      <div className="relative flex flex-wrap space-x-3 space-y-2">
        <Button
          key="cancel-btn"
          buttonName="Stay & Complete"
          buttonClass="bg-default rounded-full py-3 px-9"
          buttonType="default"
          buttonTextClass="text-black text-sm font-bold"
          onClick={() => hide(errors.menu)}
        />
        <Button
          key="cancel-btn"
          buttonName="Leave Anyway"
          buttonClass="bg-secondary rounded-full py-3 px-9"
          buttonType="secondary"
          buttonTextClass="text-white text-sm font-bold"
          onClick={() => hide("popouts")}
        />
      </div>
    );
  };

  return (
    <Modal
      footer={<Footer />}
      width="w-15/20 md:w-12/20 2md:w-9/20 3md:w-6/20"
      responsive={true}
      contentClassName="rounded-lg"
      wrapperClassName="overflow-visible"
      footerClass="border-t border-tabBorder"
    >
      <div className="w-full px-4 py-3">
        <div className="w-full flex justify-between items-center mb-3">
          <p className="text-2xl">{props?.title}</p>
          <button className="opacity-70" onClick={() => hide()}>
            <FaTimes className="opacity-70" />
          </button>
        </div>
        <p className="text-base">{props?.description}</p>
        <ul className="mt-5 w-full">
          {errors.error.map((desc, index) => (
            <li key={index} className="flex items-center space-x-3">
              <span className="text-red">&#x2022;</span>
              <span>{desc}</span>
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
}
